import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useOperatorCompactRoute } from '@/utils/operatorCompact.js';

export default function PageHeader({
  title,
  description,
  breadcrumbs = [],
  showBreadcrumb = false,
  actions,
  children,
}) {
  const { isOperatorCompact } = useOperatorCompactRoute();
  const hideTitleBlock = isOperatorCompact && !showBreadcrumb;

  if (hideTitleBlock && !actions && !children) {
    return null;
  }

  return (
    <header className={hideTitleBlock ? 'mb-1 flex flex-col gap-1' : 'mb-3 flex flex-col gap-2'}>
      <div className="flex flex-col gap-1">
        {showBreadcrumb && breadcrumbs.length ? (
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs font-medium text-[rgba(var(--muted),0.9)]">
            {breadcrumbs.map((crumb, index) => (
              <span key={crumb.href || crumb.label} className="flex items-center gap-2">
                {crumb.href ? (
                  <Link
                    to={crumb.href}
                    className="rounded-lg px-2 py-1 transition hover:text-[rgb(var(--brand))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="rounded-lg px-2 py-1 text-[rgb(var(--fg))]">{crumb.label}</span>
                )}
                {index < breadcrumbs.length - 1 ? <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" /> : null}
              </span>
            ))}
          </nav>
        ) : null}
        <div className={`flex flex-wrap ${hideTitleBlock ? 'justify-end' : 'items-start justify-between'} gap-2`}>
          {!hideTitleBlock ? (
          <div className="max-w-2xl">
            <h1 className="text-lg font-semibold tracking-tight text-[rgb(var(--fg))] lg:text-[1.25rem]">{title}</h1>
            {description ? (
              <p className="mt-0.5 text-xs text-[rgba(var(--muted),0.95)] sm:text-sm">{description}</p>
            ) : null}
          </div>
          ) : null}
          {actions ? <div className="flex flex-wrap items-center gap-1.5">{actions}</div> : null}
        </div>
      </div>
      {children ? <div className="flex flex-wrap gap-1.5">{children}</div> : null}
    </header>
  );
}
